import React from "react";

import styled from "@mui/material/styles/styled";

import { Column, StackProps } from "@rui/Stack";

type QuestionWrapperProps = StackProps & { withHoverState: boolean };

export const QuestionWrapper = styled<React.FC<QuestionWrapperProps>>(
  ({ withHoverState: _w, ...props }) => <Column {...props} />
)(({ theme, withHoverState }) => ({
  borderRadius: "4px",
  position: "relative",
  "& .key-question__add-answer": {
    display: "none",
  },
  "&:hover": {
    backgroundColor: withHoverState
      ? theme.palette.shades.ghost[300]
      : undefined,
    "& .key-question__add-answer": {
      display: "flex",
    },
  },
}));
